function _getProperties(styles, properties) {
  let style;
  properties = properties || [];
  for (let key in styles) {
    if (/\d+/.test(key)) {
      style = styles[key];
      if (properties.indexOf(style) === -1) {
        properties.push(style);
      }
    }
  }
  return properties;
}
function _getRules(rules, properties) {
  let rule;
  properties = properties || [];
  for (let i = 0, length = rules.length; i < length; i++) {
    rule = rules[i];
    properties = rule.cssRules ? _getRules(rule.cssRules, properties) : _getProperties(rule.style, properties);
  }
  return properties;
}
export default function getStylesheetProperties(stylesheet) {
  return _getRules(stylesheet.cssRules);
}